<template>
  <div class="page box">
    <div  >
  <!-- <van-tabs class="activetabs" v-model:active="active" @change="activeTabs" animated shrink v-if="childInfoList.length>0">
  <van-tab v-for="(childItem,childindex) in childInfoList" :title="childItem.studentName" :key="childindex">

   

  </van-tab>
</van-tabs>   -->
<van-sticky class="sticky">
<div>
<studentTitleCard  isChange @change="studentChange"/>
</div>
</van-sticky>
       <div class="center"  v-for="(item,i) in yearList" :key="i">
    <div v-if="!!+item.isActive">
      <van-row gutter="20">
     
      <van-col span="17" class="text_l">
        <div style="display:flex;align-items: center;height:8vh;">
          <div class="center_name">{{item.name}}</div>
          <div>
          <van-tag plain  type="success">{{['','进行中'][+item.isActive]}}</van-tag>
          </div>
        </div>
        <div style="margin-bottom:10px;">
          <span style="color: rgba(0, 0, 0, 0.4);">体测时间</span>
           {{item.startTime||''}} ~ {{item.endTime||''}}</div>
      
      </van-col>
       <van-col span="7" class="text_l"  style="display:flex;align-items: center;height:8vh;">
         <van-button type="info" style="border-radius: 10px;margin-top:10px;width:85%" size="mini" @click="onAddAppoint">预约测试</van-button>
      </van-col>
    </van-row>

    <div  style="margin-top:10px;">
        <div class="project_title">体测项目</div>
        <div class="project_ul">
            <div v-for="(itemc,ic) in item.studentProjectList"  :key='ic'  class="project_li">
            <div > {{itemc.projectName}} </div>
              <img src="@/assets/image/已测.png" alt="" width="100%" v-if="!!+itemc.isHaveScore" class="isHaveScore">

            <!-- <div  v-if="!!+itemc.isHaveScore" class="tag_span_green"> {{itemc.projectName}} </div>
            <div  v-else class="tag_span_grey"> {{itemc.projectName}} </div> -->
            </div>
        </div>
        <div class="project_baogao"  @click="onReport(item)"> 体测报告 <van-icon name="arrow" /></div>
    </div>
    <!-- <van-cell style="text-align: center;" title="体测报告" is-link  @click="onReport(item)"/> -->

    </div>

<div v-else>
<!-- 不可用测试学年 -->
    <div class="noActiceCard">
      <!-- <div  class="ifActiveBox" >
        <img src="@/assets/image/错误提示.png" width="100px"  alt="">
      </div> -->
      <van-row gutter="20">
      <van-col span="8" class="text_l">
        <van-image fit="contain" :src="require('@/assets/image/预约体测.png')"/>
      </van-col>
      <van-col span="16" class="text_l">
        <h2>{{item.name}}</h2>
        <div style="margin-bottom:10px;"> {{item.startTime||''}} ~ {{item.endTime||''}}</div>
        <div style="display:flex;justify-content: space-between;">
            <div>
                <van-button type="warning"  size="small" @click="onReport(item)">体测报告 ></van-button>
                <van-button type="warning"  size="small" style="margin-left:10px;" @click="onbodyReport(item)">测训报告 ></van-button>
            </div>
        </div>
      </van-col>
    </van-row>
    </div>
</div>

    </div>

    </div>

  </div>

</template>

<script>
import CustomButton from "@/components/CustomButton.vue";
import { getChildInfoList} from "@/api/studentBind.js";
import { checkOrder,getYearList} from "@/api/appointment.js";
import studentTitleCard from "@/components/studentTitleCard.vue";
 import { setSession ,getSession} from "@/utils/cookie";

import store from '@/store'
export default {
data () {
    return {
        childInfoList:[],
        studentInfo:{},
        active:'0',
        yearList:[],
        onStudentInfo:{}
    }
},
components: {
  CustomButton ,
  studentTitleCard
},
mounted () {
    this.init()
  
},
methods:{
   onbodyReport(item){
      let data = JSON.stringify({...this.onStudentInfo,
           termName: item.name,
      termCode:item.code,
      })
        this.$router.push({path:'bodyForging',query:{data:data}})
  },
  studentChange(val){
  this.onStudentInfo =val
  this.getYearList()
  this.checkOrder()
  },
  onReport(item){
      let data = JSON.stringify({...this.onStudentInfo,
           termName: item.name,
      termCode:item.code,
      })
        this.$router.push({path:'fitnessReport',query:{data:data}})
  },
    onAddAppoint(){
       let data = {
            snCode:this.onStudentInfo.snCode,
            schoolCode:this.onStudentInfo.schoolCode,
          }
        this.$router.push({path:'addTest',query:data})
    },
     activeTabs(){
         this.getYearList()
         this.checkOrder()
    },
    init(){
          getChildInfoList({status:'1'}).then(res=>{
        console.log(res);
        this.childInfoList = res.data.data||[]
        // if (this.childInfoList.length>0) {
        // this.onStudentInfo =  JSON.parse(getSession('studentTitleCard'))
        //  this.checkOrder()
        //  this.getYearList()
        // }
        })
      
    },
    checkOrder(){
        checkOrder({
            snCode:this.onStudentInfo.snCode,
            schoolCode:this.onStudentInfo.schoolCode,
          }).then(res=>{
            // 检查是否有准考证
            console.log(res);
            if (!+res.data.body) {
                // 没有准考证
                this.$dialog
                .alert({
                message: '请先申请电子准考证！！',
                showCancelButton: false
                }).then(() => {
                    this.$router.push({path:'admissionTicket'})
                })
        
            }   
            // res.body
          })
    },
    getYearList(){
        getYearList({
            snCode:this.onStudentInfo.snCode,
            schoolCode:this.onStudentInfo.schoolCode,
          }).then(res=>{
            res.data.data?.forEach(el => {
              el?.studentProjectList?.forEach(dl=>{
                if (dl.projectCode=='HeightWeight') {
                  dl.projectName = 'BMI'
                }
              })
            });
            this.yearList = res.data.data
          })
    },
    OnaddFaceIn(){
        if (!this.studentInfo.faceData||this.studentInfo.faceData=='') {
            this.$notify({ type: "danger", message: '请拍摄证件照！' });
            return
        }
        this.$dialog
        .alert({
          message: '是否确认生成准考证?',
          showCancelButton: true
        })
        .then(() => {
            insertIntoFaceData(this.studentInfo).then(Res=>{
            this.$notify({ type: "success", message: '生成成功！' });
            this.$router.back(-1)
            })
        })
        .catch(() => {
          // on cancel
        })
    },
   
}
}
</script>

<style lang="less" scoped>
.box{
    padding: 5px;
    font-size: 3vw;
}
.text_l{
    text-align: left;
    text-overflow:ellipsis;
    overflow:hidden;
    // white-space:nowrap;
    
}
.noActiceCard{
    position: relative;
 .ifActiveBox{
          position: absolute;
          right: 0px;
          top: 10px;
          transform: rotate(45deg);
        }
}

.project_title{
  font-size: 3.8vw;
  text-align: left;
  margin-bottom: 10px;
}
.project_ul{
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  .project_li{
    position: relative;
    width: 30%;
    height: 33px;
    margin-right: 3%;
    line-height: 33px;
    border-radius: 9px;
    font-size: 3.3vw;
    margin-bottom: 10px;
    background: rgba(0, 0, 0, 0.04);
   
}
 .isHaveScore{
      position: absolute;
      top: 0;
      right: 0;
      width: 20%;
    }

 .tag_span_green{
                border: 1px solid rgb(61, 224, 61);
    border-radius: 8px;
                color: #37cf18;
                text-align: center;
                width: 90%;
                overflow: hidden;
            }
            .tag_span_grey{
                border: 1px solid rgb(141, 135, 135);
    border-radius: 8px;
                color: #6a6d69;
                text-align: center;
                width: 90%;
                overflow: hidden;
            }
}
.project_baogao{
  text-align: center;
  font-size: 3.5vw;
  margin: 10px 0;
  color: #3c69e6;

}
 .center{
        // height: 250px;
        padding:12px;
        position: relative;
        background-color: #fff;
        border-radius: 10px;
        // border: 1px solid #ccc;
        margin: 8px;
        box-shadow: 2px 2px 3px 3px rgba(226, 225, 225, 0.6);
        .center_name{
          font-size: 4.8vw;
          font-weight: 600;
          margin-right: 10px;
          // margin: 5px 10px 15px 0px;
        }
        .center_value{
            color: #bbb;
        }
    

        .van_tag{
            // margin-left: 20px;
            text-align: center;
           
            /deep/ .van-grid-item__content{
                padding: 0px;
               border-radius: 8px;

            }
        }

        .center_text{
            text-align: left;
            font-size: 13px;
            margin-bottom: 50px;
            .center_text_title{
                font-size: 25px;
                font-weight: 700;
            }
        }
        .center_footer{
            text-align: left;
            .center_footer_title{
                font-size: 20px;
                font-weight: normal;
            }
            
            .center_footer_left{

            }
            .center_footer_right{
                .center_footer_right_value{
                font-size: 20px;
                height: 50px;
                line-height: 50px;
                border: 1px solid #bbb;
                margin-top: 10px;
                text-align: center;

            }
            }
        }
    }
</style>